import { useEffect, useState } from "react";
import { Col, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactSelect from "react-select";

import { personsSummaryQuery } from "../api";
import { personOption } from "./utils";
import { reactSelectPersonSettings } from "./reactselect";
import { useQuery } from "@tanstack/react-query";

export function PersonSelect2({ label, field, data, selectChange, disabled, supervised }) {
  const { t } = useTranslation();

  const [options, setOptions] = useState([]);

  const res = useQuery(personsSummaryQuery(supervised ? "supervised" : "all"));

  useEffect(() => {
    if (res.data) {
      const results = res.data.data.map(person => personOption(person, t));
      setOptions(results);
    }
  }, [res.data]);

  return <Form.Group as={Col}>
    { label !== undefined &&
    <Form.Label>{label}</Form.Label>
    }
    <ReactSelect
      name={field}
      inputId={field}
      //menuPlacement="bottom"
      //menuPosition="absolute"
      options={options}
      onChange={selectChange}
      isClearable
      value={data && options.find(option => option.value === data[field])}
      isDisabled={disabled}
      {...reactSelectPersonSettings(t)}
    />
    <Form.Control.Feedback type="invalid">{t("PersonIsMandatory", "Henkilö on pakollinen")}.</Form.Control.Feedback>
  </Form.Group>;
}
